import { PostIndi, useFamilyTreeAddReport } from '@ltvco/refresh-lib/fmt';
import { useSortedObitResults } from '@ltvco/refresh-lib/hooks';
import { Box } from '@ltvco/refresh-lib/theme';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { SerializedObituaryDetails } from '@ltvco/refresh-lib/v1';
import { ObituaryResultsCardv2 } from '@ltvco/refresh-lib/v2';
import React from 'react';

import { useSearchPersonResultsContext } from '../context';

import { MobileObituaryCard as MobileObituaryCardVariation1 } from './NewCardsDesignVariation1/ObituaryCards/MobileObituaryCard';
interface ObituaryResultsCardProps {
  searchObituaryResult: SerializedObituaryDetails;
  searchObituaryQuery: any;
}

export const ObituaryCards = ({
  searchObituaryResult,
  searchObituaryQuery,
}: ObituaryResultsCardProps) => {
  const { isMobile } = useScreenSize();
  const { meetMobileCardInDesktopCriteria } = useSearchPersonResultsContext();
  const sortedObits = useSortedObitResults(
    searchObituaryResult,
    searchObituaryQuery
  );
  const { handleAddToFamilyTree, isReportInTree, isCreatingFamilyTree } =
    useFamilyTreeAddReport();

  return (
    <Box sx={{ paddingX: isMobile ? 1 : 0 }}>
      {sortedObits.map((obituary: any, index: number) => {
        const reportInFamilyTree = isReportInTree(obituary.id, 'obituary_id');
        if (isMobile || meetMobileCardInDesktopCriteria) {
          return (
            <React.Fragment key={index}>
              <MobileObituaryCardVariation1
                {...obituary}
                handleAddToFamilyTree={(postIndi: PostIndi) =>
                  handleAddToFamilyTree(postIndi, obituary.id, 'obituary_id')
                }
                reportInTree={reportInFamilyTree}
                isCreatingFamilyTree={isCreatingFamilyTree}
                obituaryData={obituary}
                isExpandable={true}
              />
            </React.Fragment>
          );
        }

        return (
          <React.Fragment key={index}>
            <ObituaryResultsCardv2
              obituaryData={obituary}
              handleAddToFamilyTree={(postIndi: PostIndi) =>
                handleAddToFamilyTree(postIndi, obituary.id, 'obituary_id')
              }
              reportInTree={reportInFamilyTree}
              isCreatingFamilyTree={isCreatingFamilyTree}
            />
          </React.Fragment>
        );
      })}
    </Box>
  );
};
